import BreakPoints from 'components/style/Breakpoints.style';
import { NavbarBrand } from 'reactstrap';
import styled from 'styled-components';

export const Brand = styled(NavbarBrand).attrs({
  className: 'pl-4'
})`
  &.login {
    @media screen and (max-width: ${BreakPoints.lg}) {
      display: none;
    }
  }
`;

export const Logo = styled.img.attrs({
  className: 'img-fluid py-1',
  alt: 'logo',
  src: ({ logo }) => logo
})`
  max-height: 3.4375rem;
`;

export const MenuButton = styled.div`
  padding: 1.5rem;
  padding-left: 0.5rem;
  cursor: pointer;
  :hover {
    .close {
      opacity: 1;
    }
  }
`;

export const BurgerIcon = styled.div`
  position: relative;
  width: 20px;
  height: 2px;
  background: white;

  &::before {
    top: 5px;

    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 2px;
    background: white;
  }

  &::after {
    top: -5px;

    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 2px;
    background: white;
  }

  &.close {
    height: 0;
    top: -5px;
  }

  &.close::before {
    transform: rotate(45deg);
  }

  &.close::after {
    transform: rotate(-45deg);
    top: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LogoMenu/LogoMenu.style.js